import React, {Component} from "react";
import _ from 'i18n';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, ResponsiveContainer, ComposedChart, Bar
} from "recharts";
import {CommonLoader} from "../../../../common/CommonLoader";
import {formatAmount} from "../../../../../services/utils";
import RegistrationCAFilter from "../../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";


export default class CompareStatsChartFormat extends Component {

  prepareData = () => {
    const {data1, data2, language, chartLinesToShow, startMonth, endMonth, type, frequency, showAccumulateEventStats, formatAccumulateData, formatAccumulateCAData, formatAccumulateDataCompare, formatAccumulateCADataCompare} = this.props;

    const transformedData1 = [];
    const transformedData2 = [];

    let monthOrDaysOrYears1 = [];
    let monthOrDaysOrYears2 = [];

    Object.keys(data1).forEach(entity => {
      if (entity.length === 0) return;
      const years = data1[entity].map((element) => element.name);
      monthOrDaysOrYears1 = [...monthOrDaysOrYears1, ...years];
    });

    Object.keys(data2).forEach(entity => {
      if (entity.length === 0) return;
      const years = data2[entity].map((element) => element.name);
      monthOrDaysOrYears2 = [...monthOrDaysOrYears2, ...years];
    });

    monthOrDaysOrYears1 = [...new Set(monthOrDaysOrYears1)];
    monthOrDaysOrYears2 = [...new Set(monthOrDaysOrYears2)];

    monthOrDaysOrYears1.forEach((monthOrDayOrYear, index) => {
      const monthData = { "name": monthOrDayOrYear };

      // Loop through each entity (Utopix, KA, Lexalert, etc.)
      Object.keys(data1).forEach(entity => {
        if (entity.length === 0) return;
        // Initialize entityTotal
        let entityTotal = 0;

        // Check if the data for the specific year or time period exists for the current entity
        if (data1[entity] && data1[entity][index]) {
          // If data exists, sum the values for that month/day/year
          entityTotal = 
            data1[entity][index].formations +
            data1[entity][index].cycles +
            data1[entity][index].cycles_essential +
            data1[entity][index].saisons +
            data1[entity][index].monthly_premium +
            data1[entity][index].yearly_premium +
            data1[entity][index].congrès;
        }
        monthData[entity] = type === 'CA' ? entityTotal / 100 : entityTotal;

        // Add the total to the monthData object for the current entity
      });

      // Only push the monthData if it contains at least one entity's data
      if (Object.keys(monthData).length > 1) {
        transformedData1.push(monthData);
      }
    });

    console.log("transformedData1 ====", transformedData1);
    

    monthOrDaysOrYears2.forEach((monthOrDayOrYear, index) => {
      const monthData = { "name": monthOrDayOrYear };

      // Loop through each entity (Utopix, KA, Lexalert, etc.)
      Object.keys(data2).forEach(entity => {
        if (entity.length === 0) return;
        // Initialize entityTotal
        let entityTotal = 0;

        // Check if the data for the specific year or time period exists for the current entity
        if (data2[entity] && data2[entity][index]) {
          // If data exists, sum the values for that month/day/year
          entityTotal = 
            data2[entity][index].formations +
            data2[entity][index].cycles +
            data2[entity][index].cycles_essential +
            data2[entity][index].saisons +
            data2[entity][index].monthly_premium +
            data2[entity][index].yearly_premium +
            data2[entity][index].congrès;
        }
        monthData[entity] = type === 'CA' ? entityTotal / 100 : entityTotal;

        // Add the total to the monthData object for the current entity
      });

      // Only push the monthData if it contains at least one entity's data
      if (Object.keys(monthData).length > 1) {
        transformedData2.push(monthData);
      }
    });
    
    const data = transformedData2.map((item, index) => {
      let obj = {"data1-sum": 0, "data2-sum": 0};
      for (let key in item) {
        if (key !== "name") {
          obj["data2-" + key] = item[key];
          obj["data2-sum"] += item[key];
          obj["data1-" + key] = transformedData1[index] ? transformedData1[index][key] : 0;
          obj["data1-sum"] += transformedData1[index] ? transformedData1[index][key] : 0;
          if (type === 'CA') {
            obj["data2-" + key] /= 100;
            obj["data1-" + key] /= 100;
          }
        }
        if(key === "name"){
          obj["name"] = language !== 'fr' ? _(item.name) : item.name;
        }
      }
      if (type === 'CA') {
        obj["data2-sum"] /= 100;
        obj["data1-sum"] /= 100;
      }
      return obj;
    });

    const dataAccumulated = formatAccumulateDataCompare.map((item, index) => {
      let obj = {"data1-sum": 0, "data2-sum": 0};
      for (let key in item) {
        if (key !== "name") {
          obj["data2-" + key] = item[key];
          obj["data2-sum"] += item[key];
          obj["data1-" + key] = formatAccumulateData[index] ? formatAccumulateData[index][key] : 0;
          obj["data1-sum"] += formatAccumulateData[index] ? formatAccumulateData[index][key] : 0;
        }
        if(key === "name"){
          obj["name"] = language !== 'fr' ? _(item.name) : item.name;
        }
      }
      if (type === 'CA') {
        obj["data2-sum"] /= 100;
        obj["data1-sum"] /= 100;
      }
      return obj;
    });

    const dataCAAccumulated = formatAccumulateCADataCompare.map((item, index) => {
      let obj = {"data1-sum": 0, "data2-sum": 0};
      for (let key in item) {
        if (key !== "name") {
          obj["data2-" + key] = (item[key] / 100);
          obj["data2-sum"] += (item[key] / 100);
          obj["data1-" + key] = formatAccumulateCAData[index] ? (formatAccumulateCAData[index][key] / 100) : 0;
          obj["data1-sum"] += formatAccumulateCAData[index] ? (formatAccumulateCAData[index][key] / 100) : 0;
        }
        if(key === "name"){
          obj["name"] = language !== 'fr' ? _(item.name) : item.name;
        }
      }
      
      return obj;
    });

    return frequency === 'DAILY' ? (showAccumulateEventStats ? (type === 'CA' ? dataCAAccumulated : dataAccumulated) : data) : data.filter((elem, index) => startMonth <= index + 1 && index + 1 <= endMonth);
  }

  getBars = (keys) => {
    return keys.map((key, index) => {
      let stackId = key.includes("data2") ? "data2" : "data1";
      let fill;
      
      this.props.chartLinesToShowSeason.map((line, index) => {
        if(line.lineName.length === 0) return;
        if(key.includes(line.lineName)){
          fill = line.color;
        }
      });

      return (
        fill === undefined ? null : <Bar dataKey={key} stackId={stackId} fill={fill} opacity={stackId == "data2" ? 0.5 : 1}/>
      );
    });
  };

  render() {

    const {year1, year2, fetching, type, updateType} = this.props;

    const preparedData = this.prepareData();
    
    const preparedDataKeys = preparedData.length > 0 ? Object.keys(preparedData[0]).filter(key => !['name', 'data1-sum', 'data2-sum'].includes(key)) : [];
    const bars = this.getBars(preparedDataKeys);

    const legendPayload = [
      {value: year2, type: 'line', color: '#464646b3', id: 'data2-sum'},
      {value: year1, type: 'line', color: '#000', id: 'data1-sum'},
    ];
    

    this.prepareData();

    return (
      <React.Fragment>
        <div style={{width: '100%'}}>
          <RegistrationCAFilter type={type} updateType={updateType}/>
        </div>
        {
          fetching === true ?
            <CommonLoader containerHeight={"300px"} iconFontSize={"50px"}
                          iconColor={"#29394D"}/> :
            <ResponsiveContainer width={'100%'} height={300}>
              <ComposedChart
                data={preparedData}
                margin={{
                  top: 10,
                  right: 30
                }}
                style={{
                  fontSize: '12px',
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400
                }}
              >
                <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4"/>
                <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{fill: '#6D7F92'}}/>
                <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{fill: '#6D7F92'}} allowDecimals={false}/>
                <Tooltip content={({active, payload, label}) => {
                  if (active) {
                    return (
                      <div style={{
                        backgroundColor: '#ffffff',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid gray'
                      }}>
                        <p>{label}</p>
                        {
                          payload && payload.filter(p => ["data1-sum", "data2-sum"].includes(p.dataKey)).map(p => (
                            <p key={p.dataKey}
                               style={{color: p.stroke, fontSize: '14px'}}>
                              {legendPayload.find(legend => legend.id === p.dataKey).value}: {type === 'CA' ? formatAmount(p.value, false) : p.value}
                            </p>
                          ))
                        }
                      </div>
                    );
                  }
                  return null;
                }}/>
                {bars}
                <Line
                  dataKey={"data1-sum"}
                  stroke="#000"
                  type='monotone'
                  strokeWidth={2} 
                  isAnimationActive={true} 
                  animationDuration={2000} 
                  animationEasing="ease-out"
                />
                <Line
                  dataKey={"data2-sum"}
                  stroke="#464646b3"
                  type='monotone'
                  strokeWidth={2} 
                  isAnimationActive={true} 
                  animationDuration={2000} 
                  animationEasing="ease-out"
                />
                <Legend payload={legendPayload} iconType="line"/>
              </ComposedChart>
            </ResponsiveContainer>
        }
      </React.Fragment>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CompareStats/CompareStatsChartFormat.js